<ng-template #templatechildModal>
  <div class="modal-dialog modal-sm">
    <div class="modal-content">          
      <fa-icon [icon]="['fa','spinner']" [spin]="true" size="9x"  class="text-primary"></fa-icon>
    </div>
  </div>
</ng-template>

